import React from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import history from './history'
import T from 'i18n-react'

import store from 'configureStore'
import Routes from 'routes/routes'

T.setTexts(require('i18n/default.json'))

const ProductPage = () => {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Routes/>
      </Router>
    </Provider>
  )
}

export default ProductPage
